import React, { useEffect, useMemo } from 'react';
import { showIndependentModal } from '../Modal';
import IndependentDialog from '../IndependentDialog';
import './index.scss';

interface DebrisDetailDialogProps {
  info: { currencyIcon?: string; currencyName?: string; usedAmount?: string; usedTime?: string; description?: string };
  confirmButtonText?: string;
  closeModal?: () => void;
}

const DebrisDetailDialog = ({ info, closeModal, confirmButtonText }: DebrisDetailDialogProps) => {
  return (
    <IndependentDialog showClose={false} confirmButtonText={confirmButtonText} closeModal={closeModal}>
      <div className="debris-detail-dialog">
        <div className="debris-detail-dialog__card">
          <img src={info.currencyIcon} alt="" />
          <div className="debris-detail-dialog__card__info">
            <div className="debris-detail-dialog__card__info__name">{info.currencyName}</div>
            <div className="debris-detail-dialog__card__info__count">{'拥有数量 ：' + info.usedAmount + '个'}</div>
            <div className="debris-detail-dialog__card__info__expireTime">{'过期时间 ：' + info.usedTime}</div>
          </div>
        </div>
        <div className="debris-detail-dialog__text">{info.description}</div>
      </div>
    </IndependentDialog>
  );
};

export const showDebrisDetailDialog = ({ info = {}, confirmButtonText = '我知道啦', closeModal = () => {} }) =>
  showIndependentModal(
    <DebrisDetailDialog info={info} confirmButtonText={confirmButtonText} closeModal={closeModal} />,
    { onBottom: false },
  );
